import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: {
	headline: MessageDescriptor;
	body: MessageDescriptor;
} = defineMessages({
	headline: {
		id: 'post-office.rovo-chat.long-running-task-spotlight.headline',
		defaultMessage: 'Say hi to Max',
		description: 'Headline for long running task spotlight onboarding',
	},
	body: {
		id: 'post-office.rovo-chat.long-running-task-spotlight.body',
		defaultMessage: 'Max takes on complex, multi-step work and comes back with a finished result.',
		description: 'Body text for long running task spotlight onboarding',
	},
});
